export default {
    title: `<i class="fa fa-lg fa-pencil-square"></i> 이모지(emoji)와 뱃지`,
    datas: [
        // { type: "link",
        //     content: "StackEdit : 온라인 마크다운 편집기 (실습에 사용하세요)",
        //     url: "https://stackedit.io"
        // },
        { type: "subtitle",
            content: `<i class="fa fa-asterisk"></i> 이모지`
        },
        { type: "text",
            content: "Github의 Markdown 문서에는 :기호를 이용하여 이모지을 사용할 수 있습니다."
        },
        { type: "code2", code: "md", drag: true,
            content: `:이모지이름:`
        },
        { type: "text",
            content: "사용 가능한 이모지의 이름은 아래의 페이지에서 확인 가능합니다."
        },
        { type: "link",
            content: "EMOJI CHEAT SHEET : Github에서 사용가능한 이모지 목록",
            url: "https://www.webfx.com/tools/emoji-cheat-sheet/"
        },
        { type: "text",
            content: "이모지의 일부는 제목과 같은 부분에서 글씨 크기를 맞춰가지만 그렇지 않은 이모지도 있으니 주의해서 사용해야 합니다."
        },
        { type: "code", code: "plaintext", drag: true,
            result: "https://github.com/denlyou/sblabs_markdown_codelab_examples/blob/master/section06/exam01.md",
            content: 
`:octopus:와 :cat:이 만나서 :octocat:이 되었어요.

## :sob: 일부 이모지은 :octocat: 글씨 크기를 따라가지 않아요 :scream:`
        },
        { type: "text",
            content: "최근엔 유니코드로된 이모지을 그냥 입력하여 사용하는 경우도 많습니다."
        },
        { type: "link",
            content: "Emoji Pedia : 이모지를 검색하고 여러 운영체제 및 사이트에 모양을 확인할 수 있는 사이트",
            url: "https://emojipedia.org"
        },
        


        { type: "subtitle",
            content: `<i class="fa fa-asterisk"></i> 뱃지`
        },
        { type: "text",
            content: "Github를 돌아다니다 보면 아래 이미지의 중간 부분처럼 특정 정보를 담고 있는 작은 이미지들을 보신적이 있을 겁니다."
        },
        { type: "img",
            content: "/img/i03.png" 
        },
        { type: "text",
            content: "이것을들 뱃지라고 부르는데요, 몇몇 사이트에서 SVG를 사용하여 손쉽게 커스텀할 수 있도록 서비스를 제공하고 있습니다."
        },
        { type: "link",
            content: "Shields.io : SGV 이미지로 뱃지 만들어주는 사이트",
            url: "https://shields.io/"
        },
        { type: "text",
            content: "사이트로 들어가면 미리 제공되는 다양한 뱃지를 확인하실수 있고 중간에 보면 커스텀 사용법을 안내해 주고 있습니다."
        },
        { type: "img",
            content: "/img/i04.png" 
        },
        { type: "text",
            content: "여기서 만들어진 뱃지의 주소(url)를 마크다운의 이미지 문법이나 img 태그를 사용하여 표시할 수 있습니다."
        },
        { type: "code", code: "plaintext", drag: true,
            result: "https://github.com/denlyou/sblabs_markdown_codelab_examples/blob/master/section06/exam02.md",
            content: 
`![im hot](https://img.shields.io/badge/I'm-so_Hot-red)
<img src="https://img.shields.io/badge/You're-so_Cool-blue" alt="u cool">`
        },


        { type: "next",
            content: "다음",
            url: "/sections/07"
        },
    ]
}